import * as React from 'react';
function SvgMultipleUsersNetwork(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="multiple-users-network_svg__fil-icon"
      {...props}
    >
      <circle cx={12} cy={6.75} r={6} />
      <path d="M6 6.75h12" />
      <ellipse cx={12} cy={6.75} rx={2.25} ry={6} />
      <circle cx={4.974} cy={16.875} r={2.625} />
      <path d="M9.2 23.25a4.474 4.474 0 00-8.449 0" />
      <circle cx={19.026} cy={16.875} r={2.625} />
      <path d="M23.25 23.25a4.474 4.474 0 00-8.449 0" />
    </svg>
  );
}
export default SvgMultipleUsersNetwork;
